import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ToggleButton from "react-toggle-button";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleButton from "../../../../modules/commons/SimpleButton";

class MasterLogistikTable extends Component {
    constructor(props) {
        super(props);
        this.tableConfig = props.tableConfig;
        this.tableColumns = [
            {
                name: "",
                label: "No",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        const {page, rowsPerPage} = tableMeta.tableState;
                        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                        return <>{rowNumber}</>;
                    },
                    sort: false,
                    setCellProps: () => ({
                        style: {width: "5%"},
                    }),
                },
            },
            ...this.tableConfig,
            {
                name: "",
                label: "Action",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        return (
                            <FlexView vAlignContent="center">
                                {this.props.menuAccess && this.props.menuAccess.updateAccess && (
                                    <ToggleButton
                                        value={R.equals(this.props.data[tableMeta.rowIndex].status, "ACTIVE")}
                                        onToggle={(value) => this.handleChangeStatus(tableMeta.rowIndex, !value)}
                                    />
                                )}
                                {this.props.menuAccess && this.props.menuAccess.updateAccess && (
                                    <SimpleButton
                                        category="action_button"
                                        style={{marginRight: 15, backgroundColor: "transparent"}}
                                        icon={<i style={{fontSize: 20, color: "red"}}
                                                 className="fa fa-lw fa-pencil-alt"/>}
                                        onClick={() => this.props.onEdit(tableMeta.rowIndex)}
                                    />
                                )}

                                {typeof this.props.onDelete === "function" &&
                                    this.props.menuAccess &&
                                    this.props.menuAccess.deleteAccess &&
                                    <SimpleButton
                                        category="action_button"
                                        style={{marginRight: 15, backgroundColor: "transparent"}}
                                        icon={<i style={{fontSize: 20, color: "red"}}
                                                 className="fa fa-trash"/>}
                                        onClick={() => this.props.onDelete(tableMeta.rowIndex)}
                                    />
                                }
                            </FlexView>
                        )
                            ;
                    },
                    setCellProps: () => ({
                        style: {width: "5%"},
                    }),
                    sort: false,
                },
            },
        ];
        this.state = {
            loading: false,
        };
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleChangeStatus = (index, value) => {
        this.handleTriggerLoading();
        if (typeof this.props.onChangeStatus === "function") {
            this.props.onChangeStatus(index, value);
        }
        this.handleTriggerLoading();
    };

    handleOnChangePage = (tableState) => {
        let limit = tableState.rowsPerPage;
        let page = tableState.page + 1;
        if (typeof this.props.onChangePage === "function") {
            this.props.onChangePage(page, limit, (prevValue) => ({
                ...prevValue,
                pagination: {
                    ...prevValue.pagination,
                    page: page,
                    limit: limit,
                }
            }));
        }
    }

    handleOnChangeRowsPerPage = (tableState) => {
        let limit = tableState.rowsPerPage;
        if (typeof this.props.onChangePage === "function") {
            this.props.onChangeRowsPerPage(1, limit, (prevValue) => ({
                ...prevValue,
                pagination: {
                    ...prevValue.pagination,
                    count: 1,
                    page: 1,
                    limit: limit,
                }
            }));
        }
    }

    render() {
        return (
            <>
                <SimpleDataTable
                    tableKey={this.props.tableKey}
                    data={!R.isNil(this.props.data) ? this.props.data : []}
                    columns={this.tableColumns}
                    toCount={this.props.pagination.count}
                    rowsPerPage={this.props.pagination.limit}
                    page={this.props.pagination.page - 1}
                    options={{
                        ...defaultTableChange(this.handleOnChangePage, this.handleOnChangeRowsPerPage),
                        serverSide: true,
                    }}
                    footerAdditionalButtons={this.props.additionalButtons}
                />
                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    }
}

export default MasterLogistikTable;
